import jwtDecode from "jwt-decode";

export const decodeToken = token => {
  const decodedToken = jwtDecode(token);

  return {
    ...decodedToken,
    sub: decodedToken.sub ? decodedToken.sub : null,
    isAuthenticated: true
  };
};

// takes a JWT payload and decodes the included token
// payload is appended to the decoded data so that the access token and if included, refresh token can be stored
export const decodeTokenPayload = payload => {
  const data = decodeToken(payload.token);
  data.tokens = Object.assign({}, payload);
  return data;
};

export default {};
